<template>
  <!-- 由于数据层级过多，vue无法捕获数据，无法正常显示，所以添加一个组件来操作 -->
  <div class="setting-domain" v-if="showData">
    <div class="name">
      <span> {{setting.settingName}}</span>
      <span class="name-desc">{{setting.settingCode}}</span>
    </div>
    <div class="value">
      <span>{{prefDesc}}</span>
      <!-- 文本类型 -->
      <el-input  v-if="setting.settingDataType === 1" :style="{width: inputLength}" v-model="settingValue"  @change="save" :placeholder="settingRemark"/>

      <!-- 下拉框，单靠 -->
      <el-select v-else-if="setting.settingDataType === 2"  :style="{width: inputLength}" v-model="settingValue" @change="save" clearable>
        <el-option v-for="(item, idx) in optionList" :key="idx" :label="item.name" :value="item.code"/>
      </el-select>
      <!-- 单选类型 -->
      <el-radio  v-else-if="setting.settingDataType === 3" :style="{width: inputLength}" v-model="settingValue" v-for="(item, idx) in optionList" :label="item.code" :key="idx" @change="save">{{item.name}}</el-radio>
      <!-- 下拉框，多选 -->
      <el-select v-else-if="setting.settingDataType === 4"  :style="{width: inputLength}" v-model="settingValueMulti" @change="saveSelectMulti" multiple clearable>
        <el-option v-for="(item, idx) in optionList" :key="idx" :label="item.name" :value="item.code"/>
      </el-select>
      <el-input v-else-if="setting.settingDataType === 6"  v-model="settingValue"  @change="save" type="textarea" :rows="5"/>
      <el-color-picker v-else-if="setting.settingDataType === 7" v-model="settingValue" @change="save"/>
      <div class="rick-text" v-else-if="setting.settingDataType === 8">
        <rich-text v-model="settingValue"/>
        <div style="text-align: right">
          <page-button type="write" el-type="primary" @click="save">保存</page-button>
        </div>
      </div>
      <image-upload v-else-if="setting.settingDataType === 9" style="height: 1.5rem" v-model="settingValue" @dataChange="save" :limit="1" :use-domain="true" :url-only="true" width="1.5rem" height="1.5rem"/>
      <image-upload v-else-if="setting.settingDataType === 10" style="height: 1.5rem" v-model="settingValue" @dataChange="save" :use-domain="true" :url-only="true" width="1.5rem" height="1.5rem"/>
      <div v-else-if="setting.settingDataType === 11">
        <product-select-table class="input-all" v-model="productList" @tableSelectMulti="selectMulti" :multi="true">
          <yq-table-column label="商品别名" prop="settingLabel">
            <template v-slot="{row}">
              <el-input v-model="row.settingLabel" placeholder="请输入显示在一键报修的别名"/>
            </template>
          </yq-table-column>
          <yq-table-column label="操作" prop="options" width="60rem" align="center" fixed="right">

            <template v-slot="{$index}">
              <table-button message="是否确认删除此数据" type="delete" el-type="danger" @click="deleteRow($index)">删除</table-button>
            </template>
          </yq-table-column>
        </product-select-table>
        <div style="text-align: right">
          <page-button type="write" el-type="primary" @click="saveProductSetting">保存</page-button>
        </div>
      </div>
      <!-- 12 日期 -->
      <yq-date-picker v-else-if="setting.settingDataType === 12" :style="{width: inputLength}" v-model="settingValue" @change="save" :placeholder="settingRemark"/>
      <!--  13  时间  -->
      <el-time-picker v-if="setting.settingDataType === 13" :style="{width: inputLength}" v-model="settingValue" @change="saveTime" :placeholder="settingRemark" format="HH:mm:ss" value-format="HH:mm:ss" />
      <!-- 14 日期+时间 -->
      <yq-date-picker v-else-if="setting.settingDataType === 14" :style="{width: inputLength}" v-model="settingValue" @change="save" :placeholder="settingRemark" type="datetime" format="yyyy-MM-dd hh:mm:ss"/>
      <!-- 15 用户单选 -->
      <div v-else-if="setting.settingDataType === 15" :style="{width: inputLength, display: 'inline-block', 'vertical-align': 'middle'}" >
        <employee-select v-model="settingValue" @change="saveEmployee"/>
      </div>
      <!-- 16 用户多选 -->
      <div v-else-if="setting.settingDataType === 16" :style="{width: inputLength, display: 'inline-block', 'vertical-align': 'middle'}" class="employee-multi">
        <employee-select-multi v-model="settingValue" @change="saveEmployee"/>
      </div>
      <span>{{subDesc}}</span>
      <div class="desc">{{settingRemark}}</div>
      <div>
        <slot/>
      </div>

    </div>
  </div>
</template>

<script>
import {watch} from "vue";
import ImageUpload from "@/components/h5/image/ImageUpload.vue";
import RichText from "@/components/h5/richText/RichText.vue";
import ProductSelectTable from "@/components/h5/product/ProductSelectTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqDatePicker from "@/components/h5/date/YqDatePicker.vue";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import EmployeeSelectMulti from "@/components/h5/data/EmployeeSelectMulti.vue";
export default {
  emits: ["change"],
  props: {
    setting: {default: () => {
        return {
          settingDataType: 0,
          settingValue: "0",
          settingRemark: [],
          settingName: "",
          settingDescription: "",
          settingParams: "",
        };
      }
    },
  },
  name: "SystemComponent",
  components: {
    TableButton, YqTableColumn, ImageUpload, RichText, ProductSelectTable, YqDatePicker, EmployeeSelect, EmployeeSelectMulti
  },
  data() {
    return {
      settingValue: "",
      settingValueMulti: [],
      // 数据库里面的数据
      databaseConfig: [],
      // 描述前缀
      prefDesc: "",
      // 描述后缀
      subDesc: "",
      // 文本\数字类的描述
      settingRemark: "",
      optionList: [],
      inputLength: "75px",
      productList: [{}],
      showData: true,
    };
  },
  created() {
    this.init();
    watch(() => this.setting, () =>{
      this.init();
    }, {deep: true})
    watch(() => this.settingList, () =>{
      this.init();
    }, {deep: true})

  },
  methods: {
    init() {
      this.settingValue = this.setting.settingValue;
      if (this.setting.settingDescription) {
        let arr = this.setting.settingDescription.split("${value}");
        this.prefDesc = arr.length > 0? arr[0]: "";
        this.subDesc = arr.length > 1? arr[1]: "";
      } else {
        this.prefDesc = "";
        this.subDesc = "";
      }
      // 是下拉框时, radio
      if (this.setting.settingDataType === 2 || this.setting.settingDataType === 3) {
        this.optionList = JSON.parse(this.setting.settingParams);
        // 下拉或有参数设置时，description不再生效
      } else if (this.setting.settingDataType === 4) {
        this.optionList = JSON.parse(this.setting.settingParams);
        this.settingValueMulti = this.setting.settingValue? JSON.parse(this.setting.settingValue): [];
      } else if (this.setting.settingDataType === 11) {
        // 商品类型
        this.productList = JSON.parse(this.setting.settingValue || "[]");
      }
      this.settingRemark = this.setting.settingRemark;
      if (this.setting.inputLength) {
        this.inputLength = this.setting.inputLength * 75 + "px";
      } else {
        this.inputLength = "75px";
      }
    },
    saveTime(data) {
      if (data == null) {
        this.settingValue = "";
      }
      this.save(data || "")
    },
    // 保存用户时，change会返回用户对象，这里把参数去掉
    saveEmployee() {
      this.save();
    },
    save(data) {
      this.$emit("change", {
        id: this.setting.id,
        settingValue: data||this.settingValue,
        settingCode: this.setting.settingCode,
        settingDataType: this.setting.settingDataType,
        settingParams: this.setting.settingParams || "",
        settingCallback: this.setting.settingCallback || "",
      })
    },
    saveSelectMulti() {
      this.save(JSON.stringify(this.settingValueMulti))
    },
    // 商品相关的内容设置
    saveProductSetting() {
      let arr = [];
      for (let i = 0; i < this.productList.length; i++) {
        arr.push({
          productId: this.productList[i].productId,
          skuId: this.productList[i].skuId,
          settingLabel: this.productList[i].settingLabel,
          productName: this.productList[i].productName
        })
      }
      this.settingValue = JSON.stringify(arr);
      this.save();
    },
    // 删除一个商品
    deleteRow(index) {
      let arr = [...this.productList];
      arr.splice(index, 1);
      this.productList = arr;
    },
    // 商品多选
    selectMulti(list) {
      for (let i = 0; i < this.productList.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (this.productList[i].productId === list[j].id) {
            this.productList[i].settingLabel = list[j].productName;
            this.productList[i].skuId = list[j].id;
            this.productList[i].productId = list[j].parentId || list[j].id;
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.setting-domain{
  .name{
    display: inline-block;
    height: 40px;
    line-height: 40px;
    text-align: right;
    width: 180px;
    font-size: 14px;
    vertical-align: top;
    position: relative;
    .name-desc{
      position: absolute;
      right: 0;
      top: 20px;
      width: 100%;
      text-align: right;
      line-height: 26px;
      font-size: 10px;
      color: var(--yq-font-color-desc);
    }
  }
  .value{
    display: inline-block;
    line-height: 40px;
    padding-left: 30px;
    font-size: 14px;
    width: calc(100% - 300px);
    :deep(>.el-input),:deep(>.el-select){
      width: 80px;
    }
    .desc{
      font-size: 12px;
      color: #ccc;
      line-height: 16px;
    }
  }
  .rick-text{
    margin-top: 10px;
  }
}
:deep(.yq-date-picker){
  vertical-align: middle;
}
.employee-multi{
  :deep(.employee-business) {
    .business-content .business-item{
      vertical-align: text-bottom;
    }
    .business-content.placeholder{
      line-height: 30px;
    }
  }
}

</style>